/**
 * Created by robert.lavoie on 6/5/17.
 */

// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgStringPipesModule } from 'ngx-pipes';
import { CustomerSiteModule } from 'careerpages-base/modules/customer-site/customer-site.module';
import { AppModule as CareerPagesBaseModule } from 'careerpages-base/modules/app/app.module';

// Components
import {
  ApplyButtonComponent,
  ShareButtonComponent,
  ShareMenuComponent,
} from '../../components';

// Directives
import { TrackClickDirective } from '../../services/reporting';
import { StickyScrollDirective, ClickOutsideDirective } from '../../directives';

// Services
import { SharingService } from '../../services';

@NgModule({
  imports: [
    CommonModule,
    CareerPagesBaseModule,
    CustomerSiteModule,
    RouterModule,
    NgStringPipesModule,
  ],
  declarations: [
    ApplyButtonComponent,
    ShareButtonComponent,
    ShareMenuComponent,
    StickyScrollDirective,
    TrackClickDirective,
    ClickOutsideDirective,
  ],
  providers: [
    SharingService,
  ],
  exports: [
    ApplyButtonComponent,
    ShareButtonComponent,
    ShareMenuComponent,
    CareerPagesBaseModule,
    CommonModule,
    CustomerSiteModule,
    FormsModule,
    NgStringPipesModule,
    ReactiveFormsModule,
    RouterModule,
    StickyScrollDirective,
    TrackClickDirective,
    ClickOutsideDirective,
  ]
})
export class SharedModule {}
